/**
 * Store Card Hover Animation
 * Calculates and sets CSS variables for smooth hover effects
 */

export function initStoreCards() {
	const storeCards = document.querySelectorAll('.store-card');

	function updateStoreCardHeights() {
		storeCards.forEach((card) => {
			const details = card.querySelector('.store-card__details');
			const header = card.querySelector('.store-card__header');

			if (details && header) {
				// Get the height of details
				const detailsHeight = details.offsetHeight;
				
				// Set CSS custom property for the details height
				card.style.setProperty('--details-height', detailsHeight + 'px');
			}
		});
	}

	// Update on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateStoreCardHeights);
	} else {
		updateStoreCardHeights();
	}

	// Update on window resize
	window.addEventListener('resize', updateStoreCardHeights);

	// Reinitialize on responsive resize
	window.addEventListener('responsiveResize', updateStoreCardHeights);

	// Use ResizeObserver for dynamic content changes
	if (window.ResizeObserver) {
		const resizeObserver = new ResizeObserver(updateStoreCardHeights);
		storeCards.forEach((card) => {
			resizeObserver.observe(card);
		});
	}
}

// Initialize on module load
initStoreCards();